<template>
	<van-popup v-model="show" :position="isMobileFlag?'bottom':'center'" get-container="body" closeable
		class="bs-popup">
		<div class="bs-popup-head">
			<div class="bs-popup-tit">{{$t('验证手机')}}</div>
		</div>
		<div class="bs-popup-scroll">
			<div class="bs-popup-body">
				<el-form ref="form" :model="form">
					<el-form-item >
						<div class="flex">
							<el-select v-model="selecQu" class="qhClass" :placeholder="$t('请选择')">
								<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
							<div class="flex-col">
								<el-input v-model="form.phone" :placeholder="$t('请输入手机号')"></el-input>
							</div>
						</div>
					</el-form-item>
					<el-form-item >
						<div class="flex">
							<div class="flex-col">
								<el-input v-model="form.code" :placeholder="$t('请输入验证码')"></el-input>
							</div>
							<el-button class="get-code" type="warning">{{$t('发送验证码')}}</el-button>
						</div>
					</el-form-item>
					<el-row :gutter="20" class="btn-foot-row">
						<el-col :span="12">
							<el-button round  type="warning">{{$t('取消')}}</el-button>
						</el-col>
						<el-col :span="12">
							<el-button round type="primary" @click="onSubmit">{{$t('确定')}}</el-button>
						</el-col>
					</el-row>	
				</el-form>
			</div>
		</div>
	</van-popup>

</template>
<script>
	export default {
		components: {},
		data() {
			return {
				show: false,
				options: [{
				  value: '+1',
				  label: '+1'
				},{
				  value: '+12',
				  label: '+12'
				},{
				  value: '+13',
				  label: '+13'
				},],
				selecQu: '',
				form: {
					phone: '',
					code: '',
				}
			};
		},
		methods: {
			onSubmit() {
				console.log('submit!');
			}
		},
		mounted() {}
	}
</script>
<style scoped>
	.qhClass{
		margin-right: 10px;
	}
	.get-code{
		border-radius: 0;
		margin-left: 10px;
	}
	.btn-foot-row{
		padding: 10px 0;
	}
	.btn-foot-row .el-button{
		width: 100%;
	}
</style>